import React, { useEffect, useState, useContext } from "react";
import Flex from '@react-css/flex';
import Modal from 'react-modal';
import { StyledForm } from "../../styled-components/StyledForm.style";
import api from '../../services/api';
import Swal from "sweetalert2";
import Select from 'react-select';

export const ModalAprovacoesTransferir = ({
    usuarios,
    loadTable,
    isOpen,
    setIsOpen,
    pendenciaDeAprovacao,
    isFromProjetoInterno
}) => {
    var [selectedUsuario, setSelectedUsuario] = useState({});
    var [descricao, setDescricao] = useState(null);

    const style = {
        content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            borderRadius: "0px",
            minWidth: '35%',
            overflowY: 'auto',
            minHeight: '45%',
            maxHeight: '90%'
        },
        overlay: {
            zIndex: 9999
        }
    };

    const onAfterOpen = () => { };

    const closeModal = () => {
        setIsOpen(false);
    }

    const formActivities = async () => {
        if (selectedUsuario) {
            Swal.fire({
                title: 'Aguarde...',
                html: 'Transferindo...',
                allowEscapeKey: false,
                allowOutsideClick: false,
                showConfirmButton: false,
                willOpen: () => {
                    Swal.showLoading()
                },
            });
            if(isFromProjetoInterno) {
                await api.put(`Aprovacoes/${pendenciaDeAprovacao.idPendenciaAprovacao}/transferirpi?idAprovador=${selectedUsuario.id}`)
                .then(async (response) => {
                    await loadTable()
                    setIsOpen(false);
                    registrationSuccess();
                })
                .catch((error) => {
                    registrationFailure(error?.response?.data?.notification?.messageReturn)
                });
            }
            else
            {
                await api.put(`Aprovacoes/${pendenciaDeAprovacao.idPendenciaAprovacao}/transferir?idAprovador=${selectedUsuario.id}`)
                .then(async (response) => {
                    await loadTable()
                    setIsOpen(false);
                    registrationSuccess();
                })
                .catch((error) => {
                    registrationFailure(error?.response?.data?.notification?.messageReturn)
                });
            }
                        
                
        }
        else {
            registrationInformation();
        }
    };

    const registrationSuccess = () => {
        Swal.fire({
            title: "Sucesso",
            text: "Transferido com sucesso",
            icon: "success",
            showConfirmButton: false,
            timer: 2500,
        });
    }

    const registrationFailure = (text = "Ops, ocorreu um erro!. Tente novamente em instantes.") => {
        Swal.fire({
            title: "Atenção",
            text: text,
            icon: "error",
            confirmButtonText: "OK",
        });
    }

    const registrationInformation = () => {
        Swal.fire({
            title: "Informação",
            text: "Selecione o aprovador!",
            icon: "info",
            confirmButtonText: "OK",
        });
    }

    let usuariosFormatados = [];
    const formatPeritos = () => {
        usuarios.map(perito => {
            var item = {
                "value": perito.idUsuario,
                "id": perito.idUsuario,
                "label": `${perito.nome}`
            };
            usuariosFormatados.push(item);
        });
    }
    formatPeritos()

    const getUsuario = (usuario) => {
        if (!usuario) return

        setSelectedUsuario(usuario);
    };

    useEffect(() => {
        setSelectedUsuario(null);
        setDescricao(null);
    }, [isOpen])

    const handleDescricao = (descricao) => {
        setDescricao(descricao.target.value);
    }

    return (
        <Modal
            isOpen={isOpen}
            onAfterOpen={onAfterOpen}
            onRequestClose={closeModal}
            contentLabel="Timesheet Atividades"
            style={style}
            ariaHideApp={false}
            shouldCloseOnOverlayClick={false}
        >
            <StyledForm>
                <p className="modal-close" onClick={closeModal}>X</p>
            </StyledForm>
            <StyledForm>
                <Flex>
                    <Flex.Item className="modal-width">
                        <p className="modal-title">Transferir Aprovação</p>
                    </Flex.Item>
                </Flex>
                <Flex>
                    <Flex.Item className="modal-width">
                        <div className="position-relative form-group">
                            <div>
                                <p className="modal-info">Sigla</p>
                                <p className="modal-info-data"> {pendenciaDeAprovacao?.sigla} </p>
                                <p className="modal-info">Segurado</p>
                                <p className="modal-info-data"> {pendenciaDeAprovacao?.segurado?.seguradoNome} </p>
                                <p className="modal-info">Aprovador</p>
                                <p className="modal-info-data"> {pendenciaDeAprovacao?.nomeAprovador} </p>
                            </div>
                        </div>
                    </Flex.Item>
                    <Flex.Item className="modal-width">
                        <div className="position-relative form-group">
                            <div>
                                <p className="modal-info">Empresa </p>
                                <p className="modal-info-data">{pendenciaDeAprovacao?.nomeEmpresa} </p>
                                <p className="modal-info">Cliente</p>
                                <p className="modal-info-data"> {pendenciaDeAprovacao?.cliente?.clienteNome} </p>
                                <p className="modal-info">Disciplina</p>
                                <p className="modal-info-data"> {pendenciaDeAprovacao?.disciplina} </p>
                            </div>
                        </div>
                    </Flex.Item>
                </Flex>

                <Flex>
                    <div style={{ width: '100%' }} className="position-relative form-group">
                        <Select
                            className="basic-single"
                            placeholder={'Selecione o novo aprovador'}
                            key={selectedUsuario?.id}
                            defaultValue={[selectedUsuario]}
                            options={usuariosFormatados}
                            onChange={getUsuario}
                            maxMenuHeight="150px"
                        />
                    </div>
                </Flex>

                <Flex>
                    <div style={{ width: '100%' }} className="position-relative form-group">
                        <textarea rows="3" className="input-form" placeholder='Descrição' name='descricao' onBlur={handleDescricao} />
                    </div>
                </Flex>

                <Flex>
                    <Flex.Item className="modal-width">
                        <div className="position-relative form-group modal-align-center">
                            <input className='default-button-red' value='Transferir' type="button" onClick={formActivities} />
                        </div>
                    </Flex.Item>
                </Flex>
            </StyledForm>
        </Modal>);
};
